import { Style } from '@/components/style';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import ModalUtils from '@/utils/modalUtils';
import PrivacyModal from './components/privacyModal';

const {
  alertColor,
  blackColor,
  primaryColor,
  gray3Color,
  backgroundColor,
  secondaryColor,
} = new Style().getUiConfig();

function Privacy({ webStoreVo }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div
      style={{
        maxWidth: '640px',
        margin: '0 auto' /* 使容器水平居中 */,
      }}
    >
      {/* Privacy Modal */}
      <PrivacyModal
        show={show}
        handleClose={handleClose}
        storeDisplay={webStoreVo.displayName}
      />
      {/* Privacy Entrance */}
      <div
        className="text-center d-flex justify-content-center"
        style={{
          marginTop: '20px',
          height: '32px',
          fontSize: '9px',
          background: backgroundColor,
        }}
      >
        <span className="align-self-center">
          <div
            role="presentation"
            style={{ color: secondaryColor }}
            onClick={handleShow}
          >
            <FormattedMessage id="welcome.privacy" />
          </div>
        </span>
        <span className="align-self-center" style={{ color: gray3Color }}>
          ｜©
        </span>
        <span
          className="align-self-center"
          style={{
            marginLeft: '2px',
            color: gray3Color,
          }}
        >
          <a
            style={{ color: secondaryColor }}
            href={
              webStoreVo.supplierWebsite
                ? webStoreVo.supplierWebsite
                : 'https://www.cashier.tw/'
            }
          >
            {webStoreVo.supplierName
              ? webStoreVo.supplierName
              : '電小二智慧點餐系統'}
          </a>
        </span>
      </div>
    </div>
  );
}

Privacy.defaultProps = {
  webStoreVo: {
    supplierWebsite: 'https://www.cashier.tw/',
    supplierName: '電小二智慧點餐系統',
  },
};

Privacy.propTypes = {
  webStoreVo: PropTypes.shape({
    supplierWebsite: PropTypes.string,
    supplierName: PropTypes.string,
    displayName: PropTypes.string,
  }),
};

export default Privacy;
